export function isDevelopment(pod: string): boolean {
	switch (pod) {
		case 'dev':
		case 'dev1':
		case 'dev2':
		case 'sit1':
			return true;
		default:
			return false;
	}
}

export function isLocalDevelopment(pod: string): boolean {
	return pod === 'dev';
}
